/**
 * 考试相关路由配置
 */
export default [
  {
    path: '/exam/season/list',
    name: 'ExamSeasonList',
    component: () => import('@/views/exam/season/list.vue'),
    meta: { title: '考试报名列表' }
  },
  {
    path: '/exam/season/detail',
    name: 'ExamSeasonDetail',
    component: () => import('@/views/exam/season/detail.vue'),
    meta: { title: '考试报名详情' }
  }
]
